<div class="form-group row inputRow" *ngIf="showSearchBar">

    <div class="col-md-3 col-sm-12 col-xm-12">
        <i class="fa fa-search searchIcon" aria-hidden="true"></i>
        <input type="text" class="form-control searchInput" [(ngModel)]="searchTerm"
            (input)="filterData($event, 'contains')" placeholder="Search...">
    </div>
</div>
<p-table #dt [columns]="columnDefs" [value]="dataCopy" [resizableColumns]="true" columnResizeMode="fit"
    [scrollable]="true" scrollHeight="flex">
    <!-- Header Template -->
    <ng-template pTemplate="header" let-columns>
        <tr>
            @for (column of columns; track column) {
            @if(!column.field?.toLowerCase().endsWith("_copy")){
            @if (column?.columnType == 'checkbox') {
            <th class="table-header">
                <p-checkbox [(ngModel)]="allSelected" [binary]="true" (onChange)="toggleSelectAll($event)"></p-checkbox>
            </th>
            } @else if (column?.columnType == 'radio') {
            <th class="table-header"></th>
            }@else if (column?.columnType === 'phone' && !showContactColumn) {
            <!-- Skip rendering this column -->
            } @else {
            <th pSortableColumn="{{column.field}}" class="table-header">
                {{ column.header }}
                @if(!(column.header === 'Actions')){
                <p-sortIcon field="{{column.field}}" />
                }
            </th>
            }
            }
            }
        </tr>
    </ng-template>

    <!-- Body Template -->
    <ng-template pTemplate="body" let-currentRow let-columns="columns">
        <tr class="row-height" [ngStyle]="getRowStyle(currentRow.id)">
            @for (col of columns; track $index) {
            @if(!col.field?.toLowerCase().endsWith("_copy")){
            @if(col?.columnType === 'dropdown'){
            <td class="table-cell">
                <p-dropdown [options]="filterOptions(col?.options,currentRow['allocationType'],currentRow)"
                    appendTo="body"
                    [ngClass]="col?.header === 'Name' ? {'custom-dropdown':false} : {'custom-dropdown':true}"
                    [(ngModel)]="currentRow[col?.field]" [autoDisplay]="true" [(ngModel)]="selectedAction"
                    (onChange)="onDropdownClick($event, currentRow, col?.options)">
                    <ng-template let-option pTemplate="item">

                        <div (click)="onDropdownClick(option, currentRow, col?.options)">
                            <img [src]="option.icon" style="margin-right: 5px; width:20px; height:20px">
                            <span>{{ option.label }}</span>
                        </div>
                    </ng-template>
                </p-dropdown>
            </td>
            } @else if (col?.columnType == 'input') {
            <td class="table-cell">
                <input type="text" class="form-control" [(ngModel)]="currentRow[col?.field]" />
            </td>
            }@else if (col?.columnType == 'phone') {
            @if(showContactColumn){
            <td class="table-cell">
                <i class="fa fa-eye" (click)="onClickEyeOfContactColumn(currentRow[col?.field])"></i>
            </td>}
            } @else if (col?.columnType === 'icon') {
            <td class="table-cell icon-cell">
                <div class="icon-wrapper">
                    @for (imgInfo of currentRow[col?.field]; track $index){
                    <img [src]="imgInfo.imgSrc" [style]="{width: imgInfo.size,margin:imgInfo.margin}"
                        class="text-center" [alt]="imgInfo?.name" (click)="onIconClick(imgInfo.name, currentRow)">
                    }
                </div>
            </td>
            } @else if (col?.columnType === 'image') {
            <td class="table-cell">
                <img [src]="currentRow[col?.field]" class="image" (click)="onImageClick($event, currentRow)" alt="">
            </td>
            } @else if (col?.columnType === 'object') {
            <td class="table-cell">
                {{ currentRow[col?.field]?.[col.displayField] }}
            </td>
            } @else if (col?.columnType === 'checkbox') {
            <td class="table-cell">
                <p-checkbox [(ngModel)]="currentRow[col?.field]" [value]="currentRow?.checked"
                    (onChange)="onCheckboxChange($event, currentRow)" [binary]="true"></p-checkbox>
            </td>
            } @else if (col?.columnType === 'radio') {
            <td class="table-cell">
                <p-radioButton name="radiobutton" [value]="currentRow" [(ngModel)]="selectedItem"
                    (onClick)="onRadioChange($event, currentRow)">
                </p-radioButton>
            </td>
            }@else if (col?.columnType === 'date') {
            <td class="table-cell">
                @if(col?.config?.isUnixTime){
                {{ commonService.convertGmtToLocalTimezone(currentRow[col?.field], true) | date:col?.config?.dateFormat
                }}
                }
                @else {
                {{ commonService.convertGmtToLocalTimezone(currentRow[col?.field], false) | date:col?.config?.dateFormat
                }}
                }
            </td>
            }@else if (col?.columnType === 'hyperlink') {
            <td class="table-cell">
                <a class="hyperlink" [routerLink]="col?.route ? [col.route] : null"
                    (click)="handleHyperlinkClick($event, col, currentRow)"
                    style="cursor: pointer; text-decoration: underline; color: blue;">
                    {{ currentRow[col?.field] }}
                </a>
            </td>
            }
            @else if (col?.columnType === 'amount') {
            <td class="table-cell">
                {{ currentRow[col?.field] | indianCurrency : col?.config?.decimals != undefined ? col?.config?.decimals
                : 0 }}
            </td>
            }
            @else {
            <td class="table-cell" title="{{ currentRow[col?.tooltipField] }}">{{
                setTextLegth(currentRow[col?.field],col?.maxTextLength) }}
            </td>
            }
            }
            }
        </tr>
    </ng-template>

    <!-- Empty Message Template -->
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="columnDefs?.length" class="table-no-record">
                <span class="no-record">No record found</span>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-dialog [(visible)]="viewContactModal">
    <p-header>Contact Number</p-header>
    <p-body class="p-2 text-center">
        <div>
            <div>
                {{ viewedContactNumber }} &nbsp;&nbsp;
                <!-- <a [href]="'tel:' + viewedContactNumber" *ngIf="showCallIcon" (click)="clickToCall($event)"
                    style="text-decoration: none; color: inherit;" title="Click to call">
                    <i class="fa fa-phone" style="color: green; margin-right: 5px;"></i>
                </a> -->
            </div>
        </div>
    </p-body>
</p-dialog>